import {Graphics} from 'pixi.js';

export class Grid extends Graphics
{
    private thickness: number = 1;

    constructor() {
        super();
    }

    draw(width: number, height: number, even: boolean): void {
        this.clear();
        const cellSize = {width: 50, height: 50};
        this.lineStyle(this.thickness, even ? 0x0 : 0xffffff, 0.5);
        for (let i = 0; i < width / cellSize.width; i++) {
            this.moveTo(i * cellSize.width, 0);
            this.lineTo(i * cellSize.width, height);
        }
        for (let i = 0; i < height / cellSize.height; i++) {
            this.moveTo(0, i * cellSize.height);
            this.lineTo(width, i * cellSize.height);
        }

        this.lineStyle(2 * this.thickness, even ? 0xff3300 : 0x33ff00, 0.5);
        this.drawRect(width / 2 - 50, height / 2 - 50, 100, 100);
        this.drawRect(50, 5, width - 100, height - 100);

        this.moveTo(0, height / 2);
        this.lineTo(width, height / 2);
        this.moveTo(width / 2, 0);
        this.lineTo(width / 2, height);
    }
}
